export class Fault {
  errorId: number;
  message: string;
}
